import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { TalkService } from 'src/app/core/services/talk.service';
import { GroupSharingService } from 'src/app/features/group-sharing/group-sharing.service.component';
import Talk from 'talkjs';
declare var $: any;

declare global {
  interface Window {
    talkSession: any;
  }
}


@Component({
  selector: 'app-red-carpet-chatbar',
  templateUrl: './red-carpet-chatbar.component.html',
  styleUrls: ['./red-carpet-chatbar.component.css']
})
export class RedCarpetChatbarComponent implements OnInit {

  private inbox: Talk.Inbox;
  private session: Talk.Session;
  @ViewChild('talkjsContainer') talkjsContainer!: ElementRef;
  @Input() userId: any;
  @Input() page: any;
  @Input() eventId: string;
  conversationId: string;
  userDetails: any;
  text: any;
  contain = false;
  open = false
  groupSharingActive: boolean = false;
  groupSharingMeetingId: boolean = false;
  groupSharingDetails: any;
  constructor(private talkService: TalkService,
    private spotlightService: SpotlightService,
    private gsService: GroupSharingService) {
    this.gsService.groupSharingActive.subscribe((res: any) => {
      console.log(res)
      this.groupSharingActive = false;
      this.groupSharingMeetingId = undefined;
      this.groupSharingDetails = undefined;
      if (res) {
        let item = JSON.parse(res)
        this.groupSharingActive = item.groupSharingStarted;
        this.groupSharingMeetingId = item.eventDetails.roomId;
        this.groupSharingDetails = item.eventDetails;

      }
      $(document).ready(() => {
        if (this.page === 'redcarpet') {
          this.text = 'Red Carpet Chat';
          this.conversationId = 'redcarpet' + this.eventId;
        }
        else if (this.page === 'theaterPage') {
          this.text = 'Theater Chat';
          this.conversationId = 'theater' + this.eventId;
        } else if (this.page === 'celebrationsalon') {
          this.text = 'Chat';
          this.conversationId = 'symposiumsalon' + this.eventId;
        }
        if (this.groupSharingActive) {
          this.text = this.groupSharingDetails.description + ' ' + 'Group';
          this.conversationId = 'grp' + this.groupSharingMeetingId;
        }
        console.log('convID====>', this.conversationId);
        this.spotlightService.fetchTalkJsMetadata().toPromise().then((res: any) => {
          console.log(res);
          this.userDetails = res;
          this.userId = res.userID;
          res['userId'] = res.userID ? res.userID : res.userId
          localStorage.setItem('userData', JSON.stringify(res));
          Talk.ready.then(() => {

            const me = new Talk.User({
              id: this.userId, // convID
              name: this.userDetails.userName, // username
              email: this.userDetails.userEmail, // userEmail
            });

            const talkSession = new Talk.Session({
              appId: this.userDetails.appId,
              me,
              signature: this.userDetails.signature // 'f99b63fbb73efd8255aee36dd344d0d3c05a5d841a557147c8115faf23e25d26'
            });
            const conversation = talkSession.getOrCreateConversation(this.conversationId); // convID
            conversation.setParticipant(me);
            if(this.groupSharingActive){
              console.log(this.groupSharingDetails.participants)
              this.groupSharingDetails.participants.forEach(element => {
                const users = new Talk.User({
                  id: element.userId, // convID
                  name: element.userName, // username
                  email: element.userEmail, // userEmail
                });
                console.log(users)
                conversation.setParticipant(users);
              });
            }

            conversation.setAttributes({
              subject: 'Red Carpet',
            });
            conversation.setAttributes({custom:{ category: "redcarpet" } });

            const chatbox = talkSession.createChatbox(conversation, {
              showChatHeader: false,
            });
            chatbox.mount(document.getElementById('talkjsContainer'));
          });
        }).catch((err: any) => {
          console.log(err);
        });
      });
      window.onclick = e => {

        var targetID = e.target.id
        var clickID = 'clickID'

        if (this.open == true || (targetID != clickID && targetID != 'chat_expand_less' && targetID != 'chat_expand_more')) {
          this.closeChat()
        }

      }
    })


  }

  ngOnInit(): void {
  }

  openChat() {
    this.open = true
    $(document).click(function () {
      $('#talkjsContainer').show();
      $('#chat_expand_less').hide();
      $('#chat_expand_more').show();
    });

  }
  closeChat() {
    this.open = false
    $(document).click(function () {
      $('#talkjsContainer').hide();
      $('#chat_expand_less').show();
      $('#chat_expand_more').hide();
    });
  }


}
